<div class="container-padding">
  <div style="padding: 5%" class="container-custom">
    <app-book-title
      *ngIf="!showCustomForm && !showInfoForm && !showReview && !showCartMobile"
      booktitle="specify book date"
      info="info-booking"
    ></app-book-title>
    <div
      *ngIf="showCartMobile && !showCustomForm && !showReview && !showInfoForm"
      (click)="setCartMobile(false)"
      class="d-flex gap-1 align-items-center back"
      style="cursor: pointer"
    >
      <i class="fa fa-chevron-right"></i>
      <span>{{ "back-to-tickets" | translate }}</span>
    </div>
    <div class="mt-4">
      <app-new-choose-ticket
        [showTickets]="!showCustomForm && !showReview && !showInfoForm"
        [eventId]="eventId"
        [showCartMobile]="showCartMobile"
      ></app-new-choose-ticket>
      <app-custom-form
        (backToTickets)="showCustomForm = false"
        [customFormDetails]="customFormDetails"
        *ngIf="showCustomForm"
      ></app-custom-form>
      <app-sales-info
        (backToTickets)="showInfoForm = false"
        *ngIf="showInfoForm"
      ></app-sales-info>
      <app-review-cart
        [event]="event"
        (backToTickets)="showReview = false"
        *ngIf="showReview"
      ></app-review-cart>
    </div>
  </div>
  <div class="mt-4" *ngIf="!invoice">
    <app-book-footer
      (customForm)="goToCustomForm($event)"
      (infoForm)="goToInfoForm($event)"
      [eventId]="eventId"
      [customFormPageAppears]="showCustomForm"
      [infoFormPageAppears]="showInfoForm"
      [reviewPageAppears]="showReview"
      [backfromMobileCart]="!showCartMobile"
      (review)="goToReview()"
      (showCartMobile)="setCartMobile($event)"
    ></app-book-footer>
  </div>
</div>
